// extracted by mini-css-extract-plugin
module.exports = {"card":"TutorialCard_card__3pRkJ","cardImg":"TutorialCard_cardImg__fpZj8","titleText":"TutorialCard_titleText__18opZ"};